import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createModelCode } from '../model-code/ModelCode';

/**
 * # Dept
 *
 * Dept을 설명하세요.
 */
export const Dept = types
  .model('Dept')
  // --------------------------------------------------------------------------
  .props({
    deptSid: types.optional(types.number, 0),
    deptPsid: types.maybeNull(types.optional(types.number, 0)),
    deptNm: types.optional(types.string, ''),
    deptDescr: types.maybeNull(types.optional(types.string, '')),
    deptPnm: types.maybeNull(types.optional(types.string, '')),
    ordr: types.maybeNull(types.optional(types.number, 0)),
    deptLevelCd: types.maybeNull(createModelCode()), // ★ Req-N12: 부서 단계 (공통코드 객체)
    regDt: types.maybeNull(types.optional(types.number, 0)),
    updDt: types.maybeNull(types.optional(types.number, 0)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model dept --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IDept;
      (Object.keys(newProps) as TDeptKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TDept = Instance<typeof Dept>;
type TDeptSnapshot = SnapshotOut<typeof Dept>;

export interface IDept extends TDept {}
export type TDeptKeys = keyof TDeptSnapshot & string;
export interface IDeptSnapshot extends TDeptSnapshot {}
export const createDept = () => types.optional(Dept, {} as TDept);

export interface IDeptFilter {
  text?: string;

  page?: number;
  size?: number;
}
